/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function SearchCellsRequestPageInfoFromJSON(json) {
    return SearchCellsRequestPageInfoFromJSONTyped(json, false);
}
export function SearchCellsRequestPageInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        index: json['index'],
        size: json['size'],
    };
}
export function SearchCellsRequestPageInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        index: value.index,
        size: value.size,
    };
}
